// extracted by mini-css-extract-plugin
export default {"link":"MobileUsers_link__m7Z8M"};